module.exports = __webpack_public_path__ + "static/media/upload.ffdc33e0.svg";